import request from '@/util/request'
import localCache from '../util/localCache';
// 登陆
export function addPrice(params) {
    params.token = localCache.getToken()
    return request({
        url: '/supplierPrice',
        method: 'post',
        params
    })
}
export function updatePrice(params) {
    params.token = localCache.getToken()
    return request({
        url: '/updateSupplierPrice',
        method: 'post',
        params
    })
}
export function deletePrice(params) {
    params.token = localCache.getToken()
    return request({
        url: '/deleteSupplierPrice',
        method: 'post',
        params
    })
}
export function getPriceList(params={}) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierPriceList',
        method: 'get',
        params
    })
}
export function getPricePageList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getPricePageList',
        method: 'get',
        params
    })
}
export function getHisPriceList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getHisSupplierPriceList',
        method: 'get',
        params
    })
}
export function addSupplierPriceRelation(params) {
    params.token = localCache.getToken()
    return request({
        url: '/addSupplierPriceRelation',
        method: 'post',
        params
    })
}
export function getSupplierCurrentPrice(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierCurrentPrice',
        method: 'get',
        params
    })
}
